import { Controller } from "@hotwired/stimulus"
import tippy from "tippy.js"
// CSS for tippy.js is served separately via Propshaft (see
// vendor/assets/stylesheets/tippy.css and the stylesheet_link_tag in
// the layout). Don't import it here — esbuild's CSS-from-JS handling
// is unreliable with our build setup, and Tailwind v4's --minify
// would purge JS-injected selectors anyway.

export default class extends Controller {
  static values = {
    content: String,
    placement: { type: String, default: "top" },
    // A rail tip shows only while the rail is collapsed to icons: an open
    // rail prints the label beside the icon already.
    railCollapsedOnly: Boolean
  }

  connect() {
    this.instance = tippy(this.element, {
      content: this.contentValue || this.element.getAttribute("title"),
      placement: this.placementValue,
      allowHTML: true,
      onShow: () => {
        if (this.railCollapsedOnlyValue && document.body.dataset.rail !== "collapsed") return false
      }
    })
    this.element.removeAttribute("title")
  }

  disconnect() {
    this.instance?.destroy()
  }
}
